import { Component, OnInit, Inject, ViewChild, AfterViewInit, ViewEncapsulation, DOCUMENT } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { LoaderService } from 'src/app/core/helpers/loader.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { LocalizationService } from 'src/app/core/helpers/localization.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';


@Component({
    selector: 'loyaltic-play',
    templateUrl: './play.component.html',
    styleUrls: ['./play.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class PlayComponent implements OnInit, AfterViewInit {
  @ViewChild('noGamesAvailable', { static: false }) noGamesAvailableRef: any;

  culture = '';
  showWinComponent = false;
  showNoWinComponent = false;


  cloudinarySource = 'https://res.cloudinary.com/lojaali/video/upload/q_auto/v1600774211/finpres20/';
  status = '';
  userId: any;
  playType = '';
  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  showMainVideo = true;
  showModal: boolean;
  content: string;
  showPlayBtn: boolean;

  playResult: any;

  showSurveyScript = false;

  playAnimation = '';
  gameId = '';
  playMobileAnimation = '';
  hasPlayed = false;
  startanimation: Promise<boolean>;
  animationLoaded = false;

  message: string;
  popupKeysObj : any;
  headerKey = '';
  bodyKey = '';
  showGenericPopup = false;
  play = true;

  constructor(
    public translate: TranslateService,
    private modalService: BsModalService,
    private authService: AuthService,
    private router: Router,
    private coreService: CoreService,
    private loader: LoaderService,
    private dataService: DataServiceService,
    private gaService: GaService,
    private cookie: CookieService,
    private localizationService: LocalizationService,
    private toast: ToastrService,
    @Inject(DOCUMENT) private document: Document,
    @Inject('ImagePath') public ImagePath
  ) {
    this.localizationService.reloadTheTranslations(this.translate.getDefaultLang(), 'play');
    this.culture = translate.getDefaultLang();

    // this.dataService.getPlay.subscribe((response: any) => {
    //   // this.IsLoggedIn = response;
    //   console.log("response",response)
    // });
    this.dataService.currentMessage.subscribe(message => this.message = message);
    console.log(this.message)

  }

  winDetails = {
    availableGames: 0,
    email: '',
    gameRK: '',
    hasWon: false,
    isFreeReward: false,
    isRewardDeliverable: true,
    reward: '',
    rewardPK: '',
    rewardSmallImage: '',
    rewardDescription: '',
    rewardImage: '',
    userRewardRK: '',
    videoName: '',
    mobileVideoName: ''
  };

  captureAddress = {
    Name: '',
    Email: '',
    Phone: '',
    Address: '',
    PostalCode: '',
    City: ''
  };
  onSubmitWinWithReceipt(f) { }
  numberOnly(event) { }
  hide() {
    this.showModal = false;
  }


  onPlayClick() {
    this.getPlay();
  }

  userplay() {
    this.play = false;
    var myVideo: any = document.getElementById("gamePlay");
    myVideo.play();
  }

  ngAfterViewInit(): void {
  }


  ngOnInit() {
    // if(localStorage.getItem('playAgain') === 'true'){
    //   this.getPlay()
    // } else {
    this.gameId = localStorage.getItem('gameId');
    this.userId = this.authService.getUserId();
     if (!this.userId) {
       this.router.navigate(['/']);
       return;
     } else {
       this.showPlayBtn = true;
       this.playType = localStorage.getItem('playType');
       this.getPlay();

       /*this.coreService.getAvailableGames(this.userId).then((response: any) => {
         // response.result.availableGames = 0;  //remove this line
         if (response.result.availableGames === 0) {
           this.popupKeysObj = {
             headerKey : 'pop-generic-header',
             bodyKey :  'pop-generic-body'
           }
           // this.showGenericPopup = true;

           this.modalRef = this.modalService.show(this.noGamesAvailableRef, this.popupConfig);
         } else {
           this.getPlay()
         }
       });*/

     }
  }

  getPlay() {
    this.showSurveyScript = false;
    this.loader.isShowLoader = true;
    const playType = localStorage.getItem('playType');
    this.coreService.play(this.userId, parseInt(playType), this.gameId).subscribe((response: any) => {
      if (this.modalRef) {
        this.modalRef.hide();
      }

      let playStatus = '';
      this.playResult = response.result;
      // to check win popup remove following 2 lines
      // this.playResult.isRewardDeliverable = false;
      // this.playResult.hasWon = true;

      this.dataService.winDetails = this.playResult;
      this.winDetails = this.playResult;


      if(this.playResult.isFreeGame) {
        this.gaService.emitEvent('play_without_logo', 'Play Screen');
      } else if(!this.playResult.isFreeGame) {
        this.gaService.emitEvent('play_with_logo', 'Play Screen');
      }

      this.gaService.emitEvent('play', playStatus);
      // this.gaService.conversionEmitter("SpinTheWheel");
      if (this.playResult.hasWon) {
        // this.gaService.emitEvent('win', '1');
        this.gaService.emitEvent(this.winDetails.isRewardDeliverable ? 'Deliverable' : 'Not deliverable', 'Play Screen');
      }
      this.playAnimation = this.playResult.videoName;
      this.startanimation = Promise.resolve(true);
      this.playMobileAnimation = this.playResult.mobileVideoName;
      this.loader.isShowLoader = false;
      this.hasPlayed = true;
      this.showPlayBtn = false;
    }, (error: any) => {
      this.toast.error(this.translate.instant(error.error.messageKey));
      this.router.navigate(['/enter-code']);
    });
  }

  playAgain() {
    this.getPlay();
  }

  redirectToUpload() {
    this.modalRef.hide();
    //this.router.navigate(['home', 'PlayWithReceipt']);
    this.router.navigate(['', 'PlayWithReceipt'])
  }

  redirectToHome() {
    this.modalRef.hide();
    this.router.navigate(['/']);
  }

  pickRandom() {
    return Math.floor(Math.random() * 2) + 1;
  }

  onWinAnimationEnd() {
    this.hasPlayed = false;
    this.animationLoaded = false;
    this.showPlayBtn = true;

    if (!this.playResult.hasWon) {
      if (!this.cookie.check('noWin')) {
        this.cookie.set('noWin', 'noWin');
        this.cookie.delete('smcx_0_last_shown_at');
        this.showSurveyScript = true;
      }
    }
    if (this.playResult.hasWon) {
      this.showWinComponent = true;
      if (this.playResult.rewardPK == '2b8c3593-d974-43b8-932a-7f01b1bec14d') {
        localStorage.setItem('LoginType', 'Phone')
        localStorage.setItem('showPhone', 'true')
      } else {
        localStorage.setItem('LoginType', 'Email')
        localStorage.removeItem('showPhone');
      }
      // this.router.navigate(['win'])
      // this.modalRef = this.modalService.show(this.winPopupWithReceiptRef, this.popupConfig);
    } else if (!this.playResult.hasWon) {
      this.showNoWinComponent = true;
      // this.router.navigate(['no-win'])
      // this.modalRef = this.modalService.show(this.noWinPopupWithReceiptRef, this.popupConfig);
    }
  }

}
